<template>
  <div v-if="!loading" id="auth_page" class="invitation-page">
    <div class="invitation-container">
      <div class="content">
        <img src="@/assets/images/logo.png" id="logo" />

        <form v-if="authStore.invitation" @submit.prevent="submit">
          <h5 class="mb-4 text-center">Cadastro</h5>
          
          <div v-if="authStore.invitation.profile_type === 'Redator'" class="tab-content mt-4">
            <InputText
              name="name"
              label="Nome"
              v-model="registerForm.name"
              :error="formErrors.name"
              :disabled="authStore.invitation.name ? true : false"
              class="mb-3"
            />

            <div class="doc_type mb-3">
              <label class="mb-2">Tipo de documento</label>
              
              <div class="form-group m-radio-inline">
                <label class="m-radio m-radio--focus">
                  <input 
                    type="radio" 
                    name="document_type" 
                    value="cpf" 
                    v-model="registerForm.document_type"
                    :disabled="authStore.invitation.cpf_cnpj ? true : false"
                  />
                  CPF
                  <span></span>
                </label>

                <label class="m-radio m-radio--focus">
                  <input 
                    type="radio" 
                    name="document_type" 
                    value="cnpj" 
                    v-model="registerForm.document_type"
                    :disabled="authStore.invitation.cpf_cnpj ? true : false"
                  />
                  CNPJ
                  <span></span>
                </label>
              </div>

              <InputText
                name="cpf_cnpj"
                :mask="registerForm.document_type === 'cpf' ? '###.###.###-##' : '##.###.###/####-##'"
                v-model="registerForm.cpf_cnpj"
                :error="formErrors.cpf_cnpj"
                :disabled="authStore.invitation.cpf_cnpj ? true : false"
              />
            </div>

            <InputText
              name="email"
              label="E-mail"
              type="email"
              v-model="registerForm.email"
              :error="formErrors.email"
              disabled
              class="mb-3"
            />

            <InputText
              name="password"
              label="Senha"
              type="password"
              v-model="registerForm.password"
              :error="formErrors.password"
              class="mb-3"
            />

            <InputText
              name="password_confirmation"
              label="Confirme a senha"
              type="password"
              v-model="registerForm.password_confirmation"
              :error="formErrors.password_confirmation"
              class="mb-3"
            />

            <InputText
              name="phone"
              label="Celular"
              mask="(##) #####-####"
              v-model="registerForm.phone"
              :error="formErrors.phone"
              :disabled="authStore.invitation.phone ? true : false"
              class="mb-3"
            />

            <InputText
              name="date_birth"
              label="Data de nascimento"
              mask="##/##/####"
              v-model="registerForm.date_birth"
              :error="formErrors.date_birth"
              class="mb-3"
            />

            <div class="row">
              <div class="col-md-12 mt-4 mb-2">
                <h5>Dados bancários</h5>
              </div>
              <div class="col-md-6">
                <InputText
                  name="agency"
                  label="Agência"
                  v-model="registerForm.agency"
                  :error="formErrors.agency"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <InputText
                  name="agency_digit"
                  label="Dígito"
                  v-model="registerForm.agency_digit"
                  :error="formErrors.agency_digit"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <InputText
                  name="account"
                  label="Conta"
                  v-model="registerForm.account"
                  :error="formErrors.account"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <InputText
                  name="account_digit"
                  label="Dígito"
                  v-model="registerForm.account_digit"
                  :error="formErrors.account_digit"
                  class="mb-3"
                />
              </div>

              <div class="col-md-12 mb-2">
                <span class="text-danger">*Caso não houver dígito deixe em branco.</span>
              </div>

              <div class="col-md-6">
                <SelectBox
                  id="bank"
                  label="Banco"
                  v-model="registerForm.bank"
                  :error="formErrors.bank"
                  :items="authStore.banks?.map(bank => ({ id: bank.id, name: bank.bank_name }))"
                  placeholder="Selecione"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <SelectBox
                  id="account_type"
                  label="Tipo de conta"
                  v-model="registerForm.account_type"
                  :error="formErrors.account_type"
                  :items="[
                    { id: 'cc', name: 'Conta corrente' },
                    { id: 'cp', name: 'Conta poupança' },
                    { id: 'cf', name: 'Conta fácil' }
                  ]"
                  placeholder="Selecione"
                  class="mb-3"
                />
              </div>
            </div>

            <InputText
              name="type_content"
              label="Qual tipo de conteúdo deseja escrever?"
              v-model="registerForm.type_content"
              :error="formErrors.type_content"
              class="mb-3"
            />

            <div class="other_platform mb-3">
              <label class="mb-2">Já escreve em outra plataforma?</label>
              
              <div class="form-group m-radio-inline">
                <label class="m-radio m-radio--focus">
                  <input 
                    type="radio" 
                    name="if_other_platform" 
                    value="sim" 
                    v-model="registerForm.if_other_platform"
                  />
                  Sim
                  <span></span>
                </label>

                <label class="m-radio m-radio--focus">
                  <input 
                    type="radio" 
                    name="if_other_platform" 
                    value="" 
                    v-model="registerForm.if_other_platform"
                  />
                  Não
                  <span></span>
                </label>
              </div>

              <InputText
                v-if="registerForm.if_other_platform === 'sim'"
                name="other_platform"
                label="Qual?"
                v-model="registerForm.other_platform"
                :error="formErrors.other_platform"
                class="mt-3"
              />
            </div>

            <InputText
              name="link_article"
              label="Link de algum artigo seu publicado na internet"
              v-model="registerForm.link_article"
              :error="formErrors.link_article"
              class="mb-3"
            />

            <div class="form-group mb-3">
              <label class="mb-2">
                Faça um artigo ORIGINAL de demonstração baseado no tema abaixo. É obrigatório que ele possua o mínimo de 500 caracteres.
              </label>
              <div class="theme-box mb-3">{{ authStore.invitation.theme }}</div>
              <textarea 
                name="text" 
                class="form-control"
                v-model="registerForm.text"
                :class="{ 'is-invalid': formErrors.text }"
                rows="10"
                placeholder="Escreva seu artigo aqui..."
              ></textarea>
              <div v-if="formErrors.text" class="invalid-feedback">
                {{ formErrors.text }}
              </div>
            </div>

            <div class="form-check mb-4">
              <input 
                class="form-check-input" 
                type="checkbox" 
                id="agree"
                v-model="registerForm.agree"
                :class="{ 'is-invalid': formErrors.agree }"
              >
              <label class="form-check-label" for="agree">
                Eu concordo com os 
                <a href="#" target="_blank" class="text-primary">termos e condições</a>.
              </label>
              <div v-if="formErrors.agree" class="invalid-feedback">
                {{ formErrors.agree }}
              </div>
            </div>
          </div>

          <div v-else-if="authStore.invitation.profile_type === 'Publisher'" class="tab-content mt-4">
            <InputText
              name="name"
              label="Nome"
              v-model="registerForm.name"
              :error="formErrors.name"
              :disabled="authStore.invitation.name ? true : false"
              class="mb-3"
            />

            <div class="doc_type mb-3">
              <label class="mb-2">Tipo de documento</label>
              
              <div class="form-group m-radio-inline">
                <label class="m-radio m-radio--focus">
                  <input 
                    type="radio" 
                    name="document_type" 
                    value="cpf" 
                    v-model="registerForm.document_type"
                    :disabled="authStore.invitation.cpf_cnpj ? true : false"
                  />
                  CPF
                  <span></span>
                </label>

                <label class="m-radio m-radio--focus">
                  <input 
                    type="radio" 
                    name="document_type" 
                    value="cnpj" 
                    v-model="registerForm.document_type"
                    :disabled="authStore.invitation.cpf_cnpj ? true : false"
                  />
                  CNPJ
                  <span></span>
                </label>
              </div>

              <InputText
                name="cpf_cnpj"
                :mask="registerForm.document_type === 'cpf' ? '###.###.###-##' : '##.###.###/####-##'"
                v-model="registerForm.cpf_cnpj"
                :error="formErrors.cpf_cnpj"
                :disabled="authStore.invitation.cpf_cnpj ? true : false"
              />
            </div>

            <InputText
              name="email"
              label="E-mail"
              type="email"
              v-model="registerForm.email"
              :error="formErrors.email"
              disabled
              class="mb-3"
            />

            <InputText
              name="password"
              label="Senha"
              type="password"
              v-model="registerForm.password"
              :error="formErrors.password"
              class="mb-3"
            />

            <InputText
              name="password_confirmation"
              label="Confirme a senha"
              type="password"
              v-model="registerForm.password_confirmation"
              :error="formErrors.password_confirmation"
              class="mb-3"
            />

            <InputText
              name="phone"
              label="Celular"
              mask="(##) #####-####"
              v-model="registerForm.phone"
              :error="formErrors.phone"
              :disabled="authStore.invitation.phone ? true : false"
              class="mb-3"
            />

            <InputText
              name="date_birth"
              label="Data de nascimento"
              mask="##/##/####"
              v-model="registerForm.date_birth"
              :error="formErrors.date_birth"
              class="mb-3"
            />

            <div class="row">
              <div class="col-md-12 mt-4 mb-2">
                <h5>Dados bancários</h5>
              </div>
              <div class="col-md-6">
                <InputText
                  name="agency"
                  label="Agência"
                  v-model="registerForm.agency"
                  :error="formErrors.agency"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <InputText
                  name="agency_digit"
                  label="Dígito"
                  v-model="registerForm.agency_digit"
                  :error="formErrors.agency_digit"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <InputText
                  name="account"
                  label="Conta"
                  v-model="registerForm.account"
                  :error="formErrors.account"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <InputText
                  name="account_digit"
                  label="Dígito"
                  v-model="registerForm.account_digit"
                  :error="formErrors.account_digit"
                  class="mb-3"
                />
              </div>

              <div class="col-md-12 mb-2">
                <span class="text-danger">*Caso não houver dígito deixe em branco.</span>
              </div>

              <div class="col-md-6">
                <SelectBox
                  id="bank"
                  label="Banco"
                  v-model="registerForm.bank"
                  :error="formErrors.bank"
                  :items="authStore.banks?.map(bank => ({ id: bank.id, name: bank.bank_name }))"
                  placeholder="Selecione"
                  class="mb-3"
                />
              </div>
              <div class="col-md-6">
                <SelectBox
                  id="account_type"
                  label="Tipo de conta"
                  v-model="registerForm.account_type"
                  :error="formErrors.account_type"
                  :items="[
                    { id: 'cc', name: 'Conta corrente' },
                    { id: 'cp', name: 'Conta poupança' },
                    { id: 'cf', name: 'Conta fácil' }
                  ]"
                  placeholder="Selecione"
                  class="mb-3"
                />
              </div>
            </div>

            <div v-if="!authStore.invitation.id_manager">
              <InputText
                name="type_content"
                label="Qual tipo de conteúdo deseja compartilhar?"
                v-model="registerForm.type_content"
                :error="formErrors.type_content"
                class="mb-3"
              />

              <div class="other_platform mb-3">
                <label class="mb-2">Já divulga em outra plataforma?</label>
                
                <div class="form-group m-radio-inline">
                  <label class="m-radio m-radio--focus">
                    <input 
                      type="radio" 
                      name="if_other_platform" 
                      value="sim" 
                      v-model="registerForm.if_other_platform"
                    />
                    Sim
                    <span></span>
                  </label>

                  <label class="m-radio m-radio--focus">
                    <input 
                      type="radio" 
                      name="if_other_platform" 
                      value="" 
                      v-model="registerForm.if_other_platform"
                    />
                    Não
                    <span></span>
                  </label>
                </div>

                <InputText
                  v-if="registerForm.if_other_platform === 'sim'"
                  name="other_platform"
                  label="Qual?"
                  v-model="registerForm.other_platform"
                  :error="formErrors.other_platform"
                  class="mt-3"
                />
              </div>

              <InputText
                name="social_network"
                label="Quais redes sociais vai utilizar para divulgar o conteúdo?"
                v-model="registerForm.social_network"
                :error="formErrors.social_network"
                class="mb-3"
              />

              <div class="form-group mb-3">
                <label class="mb-2">
                  Para ter o seu cadastro aprovado como publisher da i7 Network, é necessário ter uma página no Facebook, perfil no Instagram ou Twitter com no mínimo 100 mil seguidores e fazer o procedimento abaixo:
                  <br /><br />
                  Criar um post com a hashtag #i7Network e colar a URL desse post no campo abaixo.
                  Preferencialmente, utilize a sua maior página no Facebook, perfil no Instagram ou Twitter.
                </label>
                <InputText
                  name="profile_property"
                  v-model="registerForm.profile_property"
                  :error="formErrors.profile_property"
                />
              </div>
            </div>

            <div class="form-check mb-4">
              <input 
                class="form-check-input" 
                type="checkbox" 
                id="agree"
                v-model="registerForm.agree"
                :class="{ 'is-invalid': formErrors.agree }"
              >
              <label class="form-check-label" for="agree">
                Eu concordo com os 
                <a href="https://i7.network/contrato-i7-network.pdf" target="_blank" class="text-primary">termos e condições</a>.
              </label>
              <div v-if="formErrors.agree" class="invalid-feedback">
                {{ formErrors.agree }}
              </div>
            </div>
          </div>

          <PrimaryButtonLoader v-if="submitting" class="w-100 d-block mt-4"></PrimaryButtonLoader>
          <PrimaryButton v-else type="submit" class="w-100 d-block mt-4" :disabled="!registerForm.agree">
            Cadastrar
          </PrimaryButton>
          
          <p v-if="error" class="error-message mt-3">{{ errorMessage }}</p>
        </form>

        <div v-else class="text-center">
          <p class="text-danger">Convite não encontrado ou inválido.</p>
          <div class="mt-4">
            <router-link :to="{ 'name': 'login'}">
              <p class="back-to-login">Voltar ao login</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useToast, TYPE } from "vue-toastification"
import { useAuthStore } from '@/stores/AuthStore'
import InputText from '@/components/InputText.vue'
import SelectBox from '@/components/SelectBox.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import PrimaryButtonLoader from '@/components/PrimaryButtonLoader.vue'
import { errorFormat } from "@/utils/errorFormat"

const loading = ref(false) // For initial page load
const submitting = ref(false) // For form submission
const error = ref(false)
const errorMessage = ref('')

const registerForm = ref({ 
  code: '',
  name: '', 
  email: '', 
  phone: '', 
  document_type: 'cpf',
  cpf_cnpj: '',
  password: '',
  password_confirmation: '',
  date_birth: '',
  agency: '',
  agency_digit: '',
  account: '',
  account_digit: '',
  bank: '',
  account_type: '',
  type_content: '',
  if_other_platform: '',
  other_platform: '',
  link_article: '',
  text: '',
  social_network: '',
  profile_property: '',
  agree: false
})

const router = useRouter()
const route = useRoute()
const toast = useToast()
const authStore = useAuthStore()

const formErrors = ref({})

const fetchInvitation = async () => {
  loading.value = true
  const code = route.params.code
  registerForm.value.code = code
  
  const result = await authStore.getInvitation(code)
  
  if (result.success) {
    // Pre-fill form with invitation data
    if (authStore.invitation) {
      registerForm.value.name = authStore.invitation.name || ''
      registerForm.value.email = authStore.invitation.email || ''
      registerForm.value.phone = authStore.invitation.phone || ''
      registerForm.value.document_type = authStore.invitation.document_type || 'cpf'
      registerForm.value.cpf_cnpj = authStore.invitation.cpf_cnpj || ''
    }
    
  } else {
    error.value = true
    errorMessage.value = 'Convite não encontrado ou inválido.'
  }
  
  loading.value = false
}

const submit = async () => {
  if (!authStore.invitation) {
    return
  }

  formErrors.value = {}
  submitting.value = true
  error.value = false

  const result = await authStore.registerInvitation(registerForm.value)
  
  if (result.success) {
    toast('Cadastro enviado com sucesso. Verifique seu e-mail.', { 
      type: TYPE.SUCCESS, 
      timeout: 9000 
    })
    
    router.push({ 
      name: 'login'
    })
  } else {
    if (result.errors) {
      formErrors.value = errorFormat(result.errors)
    } else {
      error.value = true
      errorMessage.value = 'Erro ao processar cadastro. Tente novamente.'
    }
  }
  
  submitting.value = false
}

onMounted(() => {
  fetchInvitation()
})
</script>

<style>
body {
  background-color: #fff !important;
}

.auth_container {
  display: block;
}
</style>

<style scoped>
.invitation-page {
  padding: 40px 20px;
  background-color: #fff;
  width: 100%;
}

.invitation-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.content {
  background-color: #fff;
  padding: 40px;
  width: 100%;
}

#logo {
  display: block;
  margin: 0 auto 30px auto;
  max-width: 200px;
  height: auto;
}

@media (max-width: 768px) {
  .invitation-page {
    padding: 10px;
  }
  
  .content {
    padding: 20px;
  }
}

.m-login__head {
  text-align: center;
  margin-bottom: 20px;
}

.tab-content {
  text-align: left;
}

.tab-content p {
  color: #6c757d;
  line-height: 1.5;
  margin-bottom: 20px;
}

.doc_type label, .other_platform label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
}

.m-radio-inline {
  display: flex;
  gap: 20px;
}

.m-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.m-radio input[type="radio"] {
  margin-right: 8px;
  width: 18px;
  height: 18px;
  margin-top: 0;
  vertical-align: middle;
}

.error-message {
  color: #df2b2b;
  font-weight: 500;
  text-align: center;
}

.back-to-login {
  color: #583a8e;
  font-weight: 500;
  cursor: pointer;
  margin: 0;
}

.back-to-login:hover {
  text-decoration: underline;
}

.theme-box {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  border-left: 4px solid #583a8e;
  font-weight: 500;
  color: #495057;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px 15px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.form-control:focus {
  border-color: #583a8e;
  box-shadow: 0 0 0 0.2rem rgba(88, 58, 142, 0.25);
  outline: 0;
}

.form-control.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
}

.form-check-input {
  margin-right: 8px;
}

.form-check-input.is-invalid {
  border-color: #dc3545;
}

.form-check-label {
  font-size: 14px;
  color: #6c757d;
}

.text-primary {
  color: #583a8e !important;
  text-decoration: none;
}

.text-primary:hover {
  text-decoration: underline;
}

.text-danger {
  color: #dc3545 !important;
}

/* Dark mode styles */
.dark .tab-content p {
  color: #8c91a8;
}

.dark .back-to-login {
  color: #b5b9d0;
}

.dark .theme-box {
  background-color: #232932;
  color: #8c91a8;
  border-left-color: #b5b9d0;
}

.dark .form-control {
  background-color: #232932;
  border-color: #3e4651;
  color: #b5b9d0;
}

.dark .form-control:focus {
  border-color: #b5b9d0;
  box-shadow: 0 0 0 0.2rem rgba(181, 185, 208, 0.25);
}

.dark .form-check-label {
  color: #8c91a8;
}

.dark .text-primary {
  color: #b5b9d0 !important;
}
</style>
